<script>
import JobBox from "ninenine-white-label/src/components/JobBox/JobBox.vue";
import FiltersBadges from "@/components/jobs/FiltersBadges.vue";
import SpinnerLoader from "ninenine-white-label/src/components/Loader/SpinnerLoader";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";

export default {
  name: "Jobs",

  data() {
    return {
      page: 0,
      endResults: false,
      isLoading: false,
      selectedState: null,
      selectedCity: null,
      selectedLevel: null,
      selectedPCD: false,
      selectedTeam: this.$route.query.area || null,
      typingJobName: null, // jobName enquanto digita
      jobName: null, // jobName após o enter
      selectedCompanyArea: null,
      process: process.env.NODE_ENV,
      stateSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
      citySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",

        score: function scoreFilter(search) {
          var text = search.toString();
          var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
          var to = "aaaaaeeeeeiiiiooooouuuunc------";

          for (var i = 0, len = from.length; i < len; i++) {
            text = text.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
          }

          var score = this.getScoreFunction(text);
          return function onScore(item) {
            var result = score(item);
            return result;
          };
        },
      },

      levelSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
    };
  },

  computed: {
    opportunities() {
      return this.$store.state.opportunities.all;
    },

    ourAreas() {
      return this.$store.state.ourAreas || [];
    },

    levels() {
      return this.$store.state.domains.professional_experience_levels || [];
    },

    states() {
      return this.$store.state.domains.states;
    },

    cities() {
      return this.$store.state.domains.cities;
    },

    teamInfos() {
      return (
        this.$store.state.teams.find(
          (team) => team.slug == this.selectedTeam
        ) || {}
      );
    },
  },

  watch: {
    selectedState: function(newValue, oldValue) {
      if (newValue) {
        this.getCities();
        this.clearFiltersAndGet();
      } else {
        this.$store.commit("location/ADD_CITIES", []);
        this.selectedCity = null;
      }
    },

    selectedCompanyArea: function(newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    selectedCity: function(newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    selectedLevel: function(newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    selectedPCD: function(newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    selectedTeam: function(newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    jobName: function(newValue, oldValue) {
      this.clearFiltersAndGet();
    },
  },

  components: {
    JobBox,
    FiltersBadges,
    SpinnerLoader,
    MagnifyIcon,
  },

  mounted() {
    // Remove o autofill para não atrabalhar o selectize
    setTimeout(() => this.removeAutoFillSelectize(), 500);

    // Busca as oportunidades
    this.clearFiltersAndGet();

    // Busca os níveis possíveis para fazer o filtro de oportunidades
    if (this.$store.state.domains.professional_experience_levels.length == 0) {
      this.$store.dispatch(
        "graphql_queries/query",
        `domains { professionalExperienceLevels {id, name} }`
      );
    }
  },

  methods: {
    submitJobName() {
      this.jobName = this.typingJobName;
    },

    clearFiltersAndGet() {
      this.$store.commit("opportunities/CLEAR_OPPORTUNITIES");
      this.page = 0;
      this.endResults = false;
      this.getJobs();
    },

    async getJobs() {
      ++this.page;
      this.isLoading = true;

      let idStates = {
        AC: "2",
        AL: "3",
        AP: "4",
        AM: "5",
        BA: "6",
        CE: "7",
        DF: "8",
        ES: "9",
        GO: "10",
        MA: "11",
        MT: "12",
        MS: "13",
        MG: "14",
        PA: "15",
        PB: "16",
        PR: "17",
        PE: "18",
        PI: "19",
        RJ: "20",
        RN: "21",
        RS: "22",
        RO: "23",
        SC: "24",
        RR: "25",
        SP: "26",
        SE: "27",
        TO: "28",
      };

      let params = {
        collection:
          this.$route.params.group == "corporativas"
            ? "corporativas"
            : this.$route.params.group,
        company_area: this.selectedCompanyArea
          ? [this.selectedCompanyArea]
          : null,
        page: this.page,
        pcd: this.selectedPCD,
        states: idStates[this.selectedState],
        city: this.selectedCity,
        level: this.selectedLevel,
        jobName: this.jobName,
      };

      const opportunities = await this.$store.dispatch(
        "opportunities/setOpportunities",
        params
      );
      this.endResults = opportunities.length < 20;
      this.isLoading = false;
    },

    getCities() {
      const params = {
        states: this.selectedState,
      };

      if (params.states && params.states.length > 0) {
        this.$store.dispatch("location/setCities", params);
      }
    },
  },
};
</script>

<template>
  <div class="job-list container mb-5">
    <div class="mt-5">
      <h2>Inscreva-se em nosso banco de talentos</h2>

      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="box__talent">
            <div class="type">Tecnologia</div>
            <div class="d-flex box__talent__content">
              <div class="img">
                <img
                  src="@/assets/images/totalpass/desenvolvimento.png"
                  alt=""
                />
              </div>
              <div class="text">
                <h4>Desenvolvedores</h4>
                <div class="d-flex footer">
                  <router-link
                    :to="
                      process == 'development'
                        ? '/vagas/27704-banco-de-talentos-desenvolvedor'
                        : '/vagas/175922-banco-de-talentos-desenvolvedores'
                    "
                    class="saiba-mais"
                    >Saiba mais</router-link
                  >
                  <router-link
                    class="vagas"
                    :to="
                      process == 'development'
                        ? '/vagas/27704-banco-de-talentos-desenvolvedor/inscricao'
                        : '/vagas/175922-banco-de-talentos-desenvolvedores/inscricao'
                    "
                  >
                    inscrever-se
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mt-3 mt-lg-0">
          <div class="box__talent">
            <div class="type">Produto</div>
            <div class="d-flex box__talent__content">
              <div class="img">
                <img src="@/assets/images/totalpass/produto.png" alt="" />
              </div>
              <div class="text">
                <h4>Produto</h4>
                <div class="d-flex footer">
                  <router-link
                    :to="
                      process == 'development'
                        ? '/vagas/27705-banco-de-talentos-produto'
                        : '/vagas/165393-banco-de-talentos-produto'
                    "
                    class="saiba-mais"
                    >Saiba mais</router-link
                  >
                  <router-link
                    class="vagas"
                    :to="
                      process == 'development'
                        ? '/vagas/27705-banco-de-talentos-produto/inscricao'
                        : '/vagas/165393-banco-de-talentos-produto/inscricao'
                    "
                  >
                    inscrever-se
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col d-flex justify-content-end" style="min-height: 40px">
        <FiltersBadges
          :jobName="jobName"
          @resetJobName="
            jobName = null;
            typingJobName = null;
          "
          :selectedStates="selectedState ? [selectedState] : []"
          @resetState="selectedState = null"
          :selectedCities="selectedCity ? [selectedCity] : []"
          @resetCity="selectedCity = null"
          :selectedLevel="selectedLevel"
          @resetLevel="selectedLevel = null"
          :selectedPCD="selectedPCD"
          @resetPCD="selectedPCD = false"
          :selectedTeam="selectedTeam"
          @resetTeam="selectedTeam = null"
        />
      </div>
    </div>
    <h2>Confira as vagas abertas</h2>
    <div class="row align-items-center">
      <div class="col-12 col-sm-12 col-lg-8">
        <form v-on:submit.prevent="submitJobName()" novalidate>
          <div class="input-group mb-4 mb-lg-0">
            <input
              type="text"
              v-model="typingJobName"
              class="
                form-control
                rounded-xl
                border
                input-custom
                font-sans-serif-regular
                border-right-0
              "
              placeholder="Digite o nome da vaga"
              style="height: auto"
            />
            <div class="input-group-append">
              <button
                class="
                  btn btn-white
                  border
                  rounded-xl
                  border-left-0 border-radius-right-2
                "
                type="button"
                @click="submitJobName()"
              >
                <magnify-icon class="h4 my-1 text-muted" />
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="col-12 col-sm-12 col-lg-4" style="margin-top: -0.8rem">
        <selectize
          v-model="selectedCompanyArea"
          class="rounded-xl font-sans-serif-regular"
          placeholder="Áreas"
        >
          <option
            :value="area.id"
            v-for="(area, index) in ourAreas"
            :key="index"
          >
            {{ area.title }}
          </option>
        </selectize>
      </div>
    </div>

    <div class="row mt-5">
      <JobBox
        :opportunity="opportunity"
        v-for="(opportunity, id) in opportunities"
        :key="id"
        :id="id"
        :btnSubscriptionText="'Inscreva-se'"
        :showDescriptionPage="false"
        :showModalKnowMoreButton="true"
        class="col-12 col-lg-4 col-md-6 mb-4"
      />

      <div class="col-12">
        <SpinnerLoader v-if="isLoading" />

        <button
          @click="getJobs()"
          class="btn btn-color-1 d-block mx-auto"
          v-if="!isLoading && !endResults"
        >
          Carregar mais
        </button>

        <div v-if="!isLoading && !opportunities.length">
          <p class="text-muted text-center">
            Nenhum resultado encontrado para esse filtro:
          </p>
        </div>

        <div v-if="!isLoading && opportunities.length && endResults">
          <p class="text-muted text-center">
            Todas as oportunidades foram listadas
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.box__talent {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 18px #00000021;
  border-radius: 9px;
  .type {
    background-color: rgba(#26e88a, 0.12);
    color: #080808;
    font-weight: 500;
    line-height: 30px;
    padding-left: 2rem;
    text-transform: uppercase;
  }
  &__content {
    padding: 2rem;
    box-sizing: border-box;
    @include media-breakpoint-down(sm) {
      flex-flow: row wrap;
    }
  }
  .img {
    width: 250px;
    height: 110px;
    overflow: hidden;
    img {
      height: 100%;
      width: auto !important;
      max-width: 700px !important;
    }
    @include media-breakpoint-down(sm) {
      width: 100%;
      height: auto;
      img {
        height: auto;
        width: 100% !important;
        max-width: 700px !important;
      }
    }
  }
  .text {
    height: auto;
    padding-left: 2rem;
    margin: 0px;
    width: 100%;
    h4 {
      font-weight: bold;
      font-style: italic;
      font-family: "Poppins", sans-serif;
      @include media-breakpoint-down(sm) {
        margin-top: 1.5rem;
      }
    }
    .footer {
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      flex-flow: row wrap;
      width: 100%;
      @include media-breakpoint-down(sm) {
        margin-top: 1.5rem;
      }
      a {
        font-family: "Poppins", sans-serif;
        font-size: 1.2rem;
        line-height: 40px;
      }
      .vagas {
        background-color: #26e88a;
        color: #080808;
        padding: 0px 1.5rem;
        font-weight: bold;
      }
      .saiba-mais {
        color: #5d646c;
        font-style: italic;
        font-weight: 300;
      }
    }
  }
}

h2 {
  text-align: center;
  font-size: 3rem !important;
  margin-bottom: 3rem;
}
h1 {
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 62px;
  &:before,
  &:after {
    content: "";
    width: auto;
    height: 4px;
    background: theme-color("color-1");
    flex-grow: 1;
    border-radius: 30px;
  }
  &:before {
    margin-right: 60px;
    @include media-breakpoint-down(md) {
      margin-right: 15px;
    }
  }
  &:after {
    margin-left: 60px;
    @include media-breakpoint-down(md) {
      margin-left: 15px;
    }
  }
}

/deep/ select.rounded-xl + .selectize-control {
  & > .selectize-input {
    border-radius: inherit;
  }
}
</style>
